export default {
  PERSONAL: 'personal',
  TEAM: 'team',
  WORKING_MODE: 'working-mode',
}
